
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M487.1 451.028h-51.877v51.834c0 4.771-3.87 8.639-8.646 8.639h-17.292c-4.775 0-8.646-3.867-8.646-8.639v-51.834h-51.878c-4.775 0-8.646-3.867-8.646-8.639v-17.278c0-4.771 3.87-8.639 8.646-8.639h51.878v-51.834c0-4.771 3.87-8.639 8.646-8.639h17.292c4.776 0 8.646 3.867 8.646 8.639v51.834H487.1c4.775-.001 8.646 3.867 8.646 8.639v17.278c0 4.772-3.871 8.639-8.646 8.639zm-183.222-17.389c0 10.424 1.396 20.506 3.956 30.09-22.949 2.021-49.376 3.278-79.749 3.278-120.882 0-180.038-19.737-201.726-29.378-5.597-2.488-10.105-9.602-10.105-15.722v-41.291c0-61.876 47.15-113.208 107.314-120.083 1.828-.21 4.54.572 6.03 1.651 27.74 20.065 61.701 32.041 98.488 32.041 36.788 0 70.749-11.976 98.489-32.041 1.489-1.079 4.201-1.861 6.029-1.651 39.202 4.48 72.813 27.863 91.497 60.721a107.186 107.186 0 00-10.85-.557c-60.404 0-109.373 50.566-109.373 112.942zm-75.793-182.608c-69.239 0-125.369-56.084-125.369-125.267S158.846.499 228.085.499c69.24 0 125.37 56.084 125.37 125.267 0 69.181-56.13 125.265-125.37 125.265z"}})])
          )
        }
      }
    